module.exports = __webpack_public_path__ + "img/c01_unittechhypaspistchampion_Normal_ua.22e959a6.webp";